import { useEffect as o } from "react";
import { disablePageScroll as r, enablePageScroll as l } from "./index.es500.js";
var a = function a(e) {
  o(function () {
    return r(), function () {
      l();
    };
  }, [e]);
};
export { a as usePageScrollLock };